import { Component } from 'react';

/** Components */
import Keypad from './Keypad';
import LatexKeypadButton from './LatexKeypadButton';
import KeypadButton from './KeypadButton';

class ComplexMath extends Component {
  render() {
    return (
      <Keypad className="complex-math" {...this.props}>
        <div>
          {/* Symbols */}
          <LatexKeypadButton label="x" />
          <LatexKeypadButton label="x^2" value="^2" />
          <LatexKeypadButton label="x^{}" />
          <LatexKeypadButton label="x_{}" />
          <LatexKeypadButton label="\sqrt{}" />
          {/* Fractions */}
          <LatexKeypadButton label="\frac{}{}" />
          <LatexKeypadButton label="x\frac{}{}" />
        </div>
        <div>
          <LatexKeypadButton label="y" />
          {}
          <LatexKeypadButton label="({})" />
          <LatexKeypadButton label="[{}]" />
          <LatexKeypadButton label="|{}|" />
          {/* Symbols */}
          <KeypadButton label="&plusmn;" />
          <LatexKeypadButton label="\sqrt[]{}" />
          <KeypadButton label="%" />
        </div>
        <div>
          {/* Symbols */}
          <KeypadButton label="&lt;" />
          <KeypadButton label="&gt;" />
          <KeypadButton label="&ge;" />
          <KeypadButton label="&le;" />
          <KeypadButton label="&#8776;" />
          <KeypadButton label="&ne;" />
          <KeypadButton label="&#36;" />
        </div>
        <div>
          {/* Geometry & Trigonometry */}
          <KeypadButton label="&pi;" />
          <KeypadButton label="log" />
          <KeypadButton label="cos" />
          <KeypadButton label="sin" />
          <KeypadButton label="tan" />
          <KeypadButton label="sec" />
          <KeypadButton label="cot" />
        </div>
        <div>
          {/* Calculus */}
          <LatexKeypadButton label="\int" />
          <LatexKeypadButton label="\int_{}^{}" />
          {/* Greek Alpha */}
          <LatexKeypadButton label="\alpha" />
          <LatexKeypadButton label="\beta" />
          <LatexKeypadButton label="\theta" />
          <LatexKeypadButton label="\Sigma" />
          <LatexKeypadButton label="\mu" />
        </div>
        <div>
          {/* Logic */}
          <LatexKeypadButton label="\therefore" />
          <LatexKeypadButton label="\to" />
          <LatexKeypadButton label="\Leftrightarrow" />
          <LatexKeypadButton label="\Rightarrow" />
          {/* Set Theory */}
          <LatexKeypadButton label="\in" />
          <LatexKeypadButton label="\cap" />
          <LatexKeypadButton label="\cup" />
        </div>
        <div>
          {/* Geometry & Trigonometry */}
          <LatexKeypadButton label="\angle" />
          <LatexKeypadButton label="\overline{x}" />
          <LatexKeypadButton label="\circ" />
          {/* Symbols */}
          <KeypadButton label="&prime;" />
          <LatexKeypadButton label="\infinity" />
          {/** Calculus */}
          <LatexKeypadButton label="\binom{}{}" />
        </div>
      </Keypad>
    );
  }
}

export default ComplexMath;
